module.exports = __webpack_public_path__ + "static/img/5.6cd43006.png";